export default __webpack_public_path__ + "static/media/small-logo.6b3d2b20.png";